// Code generated by pbe. DO NOT EDIT.
import { BoolValue as values__BoolValue, Int64Value as values__Int64Value, Value as values__Value } from '../values/values.pbe';
import { NewFields, ProtoMessage } from '../../runtime';
export var Namespaces_Status = /*#__PURE__*/function (Namespaces_Status) {
  Namespaces_Status[Namespaces_Status["OK"] = 0] = "OK";
  Namespaces_Status[Namespaces_Status["UNKNOWN_ERROR"] = 1] = "UNKNOWN_ERROR";
  return Namespaces_Status;
}(Namespaces_Status || {});
export class ChannelArgs extends ProtoMessage {
  static fromBinary(data) {
    return this.fromBinaryMerge(data, new ChannelArgs());
  }
}
ChannelArgs._fqn = 'service.ChannelArgs';
ChannelArgs._fields = NewFields([[1, {
  name: 'census',
  json: 'census',
  type: 11,
  ctor: () => values__Value
}], [2, {
  name: 'loadreporting',
  json: 'loadreporting',
  type: 11,
  ctor: () => values__Value
}], [3, {
  name: 'minimalStack',
  json: 'minimal_stack',
  type: 11,
  ctor: () => values__Value
}], [4, {
  name: 'maxConcurrentStreams',
  json: 'max_concurrent_streams',
  type: 11,
  ctor: () => values__Value
}], [5, {
  name: 'maxReceiveMessageLength',
  json: 'max_receive_message_length',
  type: 11,
  ctor: () => values__Int64Value
}], [6, {
  name: 'maxSendMessageLength',
  json: 'max_send_message_length',
  type: 11,
  ctor: () => values__Int64Value
}], [7, {
  name: 'maxConnectionIdleMs',
  json: 'max_connection_idle_ms',
  type: 11,
  ctor: () => values__Value
}], [8, {
  name: 'maxConnectionAgeMs',
  json: 'max_connection_age_ms',
  type: 11,
  ctor: () => values__Value
}], [9, {
  name: 'maxConnectionAgeGraceMs',
  json: 'max_connection_age_grace_ms',
  type: 11,
  ctor: () => values__Value
}], [10, {
  name: 'clientIdleTimeoutMs',
  json: 'client_idle_timeout_ms',
  type: 11,
  ctor: () => values__Value
}], [11, {
  name: 'perMessageCompression',
  json: 'per_message_compression',
  type: 11,
  ctor: () => values__Value
}], [12, {
  name: 'perMessageDecompression',
  json: 'per_message_decompression',
  type: 11,
  ctor: () => values__Value
}], [13, {
  name: 'enableDeadlineChecking',
  json: 'enable_deadline_checking',
  type: 11,
  ctor: () => values__Value
}], [14, {
  name: 'http2',
  json: 'http2',
  type: 11,
  ctor: () => ChannelArgs_HTTP2
}], [15, {
  name: 'http2Scheme',
  json: 'http2_scheme',
  type: 11,
  ctor: () => values__Value
}], [16, {
  name: 'keepaliveTimeMs',
  json: 'keepalive_time_ms',
  type: 11,
  ctor: () => values__Value
}], [17, {
  name: 'keepaliveTimeoutMs',
  json: 'keepalive_timeout_ms',
  type: 11,
  ctor: () => values__Value
}], [18, {
  name: 'keepalivePermitWithoutCalls',
  json: 'keepalive_permit_without_calls',
  type: 11,
  ctor: () => values__Value
}], [19, {
  name: 'defaultAuthority',
  json: 'default_authority',
  type: 11,
  ctor: () => values__Value
}], [20, {
  name: 'primaryUserAgent',
  json: 'primary_user_agent',
  type: 11,
  ctor: () => values__Value
}], [21, {
  name: 'secondaryUserAgent',
  json: 'secondary_user_agent',
  type: 11,
  ctor: () => values__Value
}], [22, {
  name: 'minReconnectBackoffMs',
  json: 'min_reconnect_backoff_ms',
  type: 11,
  ctor: () => values__Value
}], [23, {
  name: 'maxReconnectBackoffMs',
  json: 'max_reconnect_backoff_ms',
  type: 11,
  ctor: () => values__Value
}], [24, {
  name: 'initialReconnectBackoffMs',
  json: 'initial_reconnect_backoff_ms',
  type: 11,
  ctor: () => values__Value
}], [25, {
  name: 'dnsMinTimeBetweenResolutionsMs',
  json: 'dns_min_time_between_resolutions_ms',
  type: 11,
  ctor: () => values__Value
}], [26, {
  name: 'serverHandshakeTimeoutMs',
  json: 'server_handshake_timeout_ms',
  type: 11,
  ctor: () => values__Value
}], [27, {
  name: 'sslTargetNameOverride',
  json: 'ssl_target_name_override',
  type: 11,
  ctor: () => values__Value
}], [28, {
  name: 'sslSessionCache',
  json: 'ssl_session_cache',
  type: 11,
  ctor: () => values__Value
}], [29, {
  name: 'tsi',
  json: 'tsi',
  type: 11,
  ctor: () => ChannelArgs_TSI
}], [30, {
  name: 'maxMetadataSize',
  json: 'max_metadata_size',
  type: 11,
  ctor: () => values__Value
}], [31, {
  name: 'soReuseport',
  json: 'so_reuseport',
  type: 11,
  ctor: () => values__Value
}], [32, {
  name: 'resourceQuota',
  json: 'resource_quota',
  type: 11,
  ctor: () => values__Value
}], [33, {
  name: 'expandWildcardAddrs',
  json: 'expand_wildcard_addrs',
  type: 11,
  ctor: () => values__Value
}], [34, {
  name: 'serviceConfig',
  json: 'service_config',
  type: 11,
  ctor: () => values__Value
}], [35, {
  name: 'serviceConfigDisableResolution',
  json: 'service_config_disable_resolution',
  type: 11,
  ctor: () => values__Value
}], [36, {
  name: 'lbPolicyName',
  json: 'lb_policy_name',
  type: 11,
  ctor: () => values__Value
}], [37, {
  name: 'socketMutator',
  json: 'socket_mutator',
  type: 11,
  ctor: () => values__Value
}], [38, {
  name: 'socketFactory',
  json: 'socket_factory',
  type: 11,
  ctor: () => values__Value
}], [39, {
  name: 'maxChannelTraceEventMemoryPerNode',
  json: 'max_channel_trace_event_memory_per_node',
  type: 11,
  ctor: () => values__Value
}], [40, {
  name: 'enableChannelz',
  json: 'enable_channelz',
  type: 11,
  ctor: () => values__Value
}], [41, {
  name: 'useCronetPacketCoalescing',
  json: 'use_cronet_packet_coalescing',
  type: 11,
  ctor: () => values__Value
}], [42, {
  name: 'experimental',
  json: 'experimental',
  type: 11,
  ctor: () => ChannelArgs_Experimental
}], [43, {
  name: 'grpclbCallTimeoutMs',
  json: 'grpclb_call_timeout_ms',
  type: 11,
  ctor: () => values__Value
}], [44, {
  name: 'grpclbFallbackTimeoutMs',
  json: 'grpclb_fallback_timeout_ms',
  type: 11,
  ctor: () => values__Value
}], [45, {
  name: 'priorityFailoverTimeoutMs',
  json: 'priority_failover_timeout_ms',
  type: 11,
  ctor: () => values__Value
}], [46, {
  name: 'workaround',
  json: 'workaround',
  type: 11,
  ctor: () => ChannelArgs_Workaround
}], [47, {
  name: 'optimizationTarget',
  json: 'optimization_target',
  type: 11,
  ctor: () => values__Value
}], [48, {
  name: 'enableRetries',
  json: 'enable_retries',
  type: 11,
  ctor: () => values__Value
}], [49, {
  name: 'perRpcRetryBufferSize',
  json: 'per_rpc_retry_buffer_size',
  type: 11,
  ctor: () => values__Value
}], [50, {
  name: 'mobileLogContext',
  json: 'mobile_log_context',
  type: 11,
  ctor: () => values__Value
}], [51, {
  name: 'disableClientAuthorityFilter',
  json: 'disable_client_authority_filter',
  type: 11,
  ctor: () => values__Value
}], [52, {
  name: 'enableHttpProxy',
  json: 'enable_http_proxy',
  type: 11,
  ctor: () => values__BoolValue
}], [53, {
  name: 'httpProxy',
  json: 'http_proxy',
  type: 11,
  ctor: () => values__Value
}], [54, {
  name: 'surfaceUserAgent',
  json: 'surface_user_agent',
  type: 11,
  ctor: () => values__Value
}], [55, {
  name: 'inhibitHealthChecking',
  json: 'inhibit_health_checking',
  type: 11,
  ctor: () => values__Value
}], [56, {
  name: 'dnsEnableSrvQueries',
  json: 'dns_enable_srv_queries',
  type: 11,
  ctor: () => values__Value
}], [57, {
  name: 'dnsAresQueryTimeout',
  json: 'dns_ares_query_timeout',
  type: 11,
  ctor: () => values__Value
}], [58, {
  name: 'useLocalSubchannelPool',
  json: 'use_local_subchannel_pool',
  type: 11,
  ctor: () => values__Value
}], [59, {
  name: 'channelPoolingDomain',
  json: 'channel_pooling_domain',
  type: 11,
  ctor: () => values__Value
}], [60, {
  name: 'channelId',
  json: 'channel_id',
  type: 11,
  ctor: () => values__Value
}]]);
export class ChannelArgs_Experimental extends ProtoMessage {
  static fromBinary(data) {
    return this.fromBinaryMerge(data, new ChannelArgs_Experimental());
  }
}
ChannelArgs_Experimental._fqn = 'service.ChannelArgs.Experimental';
ChannelArgs_Experimental._fields = NewFields([[1, {
  name: 'tcpReadChunkSize',
  json: 'tcp_read_chunk_size',
  type: 11,
  ctor: () => values__Value
}], [2, {
  name: 'tcpMinReadChunkSize',
  json: 'tcp_min_read_chunk_size',
  type: 11,
  ctor: () => values__Value
}], [3, {
  name: 'tcpMaxReadChunkSize',
  json: 'tcp_max_read_chunk_size',
  type: 11,
  ctor: () => values__Value
}], [4, {
  name: 'tcpTxZerocopyEnabled',
  json: 'tcp_tx_zerocopy_enabled',
  type: 11,
  ctor: () => values__Value
}], [5, {
  name: 'tcpTxZerocopySendBytesThreshold',
  json: 'tcp_tx_zerocopy_send_bytes_threshold',
  type: 11,
  ctor: () => values__Value
}], [6, {
  name: 'tcpTxZerocopyMaxSimultaneousSends',
  json: 'tcp_tx_zerocopy_max_simultaneous_sends',
  type: 11,
  ctor: () => values__Value
}]]);
export class ChannelArgs_HTTP2 extends ProtoMessage {
  static fromBinary(data) {
    return this.fromBinaryMerge(data, new ChannelArgs_HTTP2());
  }
}
ChannelArgs_HTTP2._fqn = 'service.ChannelArgs.HTTP2';
ChannelArgs_HTTP2._fields = NewFields([[1, {
  name: 'initialSequenceNumber',
  json: 'initial_sequence_number',
  type: 11,
  ctor: () => values__Value
}], [2, {
  name: 'lookaheadBytes',
  json: 'lookahead_bytes',
  type: 11,
  ctor: () => values__Value
}], [3, {
  name: 'hpackTableSize',
  json: 'hpack_table_size',
  type: 11,
  ctor: () => ChannelArgs_HTTP2_HPackTableSize
}], [4, {
  name: 'maxFrameSize',
  json: 'max_frame_size',
  type: 11,
  ctor: () => values__Value
}], [5, {
  name: 'bdpProbe',
  json: 'bdp_probe',
  type: 11,
  ctor: () => values__Value
}], [6, {
  name: 'minPingIntervalWithoutDataMs',
  json: 'min_ping_interval_without_data_ms',
  type: 11,
  ctor: () => values__Value
}], [7, {
  name: 'maxPingsWithoutData',
  json: 'max_pings_without_data',
  type: 11,
  ctor: () => values__Value
}], [8, {
  name: 'maxPingStrikes',
  json: 'max_ping_strikes',
  type: 11,
  ctor: () => values__Value
}], [9, {
  name: 'writeBufferSize',
  json: 'write_buffer_size',
  type: 11,
  ctor: () => values__Value
}], [10, {
  name: 'trueBinary',
  json: 'true_binary',
  type: 11,
  ctor: () => values__Value
}]]);
export class ChannelArgs_HTTP2_HPackTableSize extends ProtoMessage {
  static fromBinary(data) {
    return this.fromBinaryMerge(data, new ChannelArgs_HTTP2_HPackTableSize());
  }
}
ChannelArgs_HTTP2_HPackTableSize._fqn = 'service.ChannelArgs.HTTP2.HPackTableSize';
ChannelArgs_HTTP2_HPackTableSize._fields = NewFields([[1, {
  name: 'decoder',
  json: 'decoder',
  type: 11,
  ctor: () => values__Value
}], [2, {
  name: 'encoder',
  json: 'encoder',
  type: 11,
  ctor: () => values__Value
}]]);
export class ChannelArgs_TSI extends ProtoMessage {
  static fromBinary(data) {
    return this.fromBinaryMerge(data, new ChannelArgs_TSI());
  }
}
ChannelArgs_TSI._fqn = 'service.ChannelArgs.TSI';
ChannelArgs_TSI._fields = NewFields([[1, {
  name: 'maxFrameSize',
  json: 'max_frame_size',
  type: 11,
  ctor: () => values__Value
}]]);
export class ChannelArgs_Workaround extends ProtoMessage {
  static fromBinary(data) {
    return this.fromBinaryMerge(data, new ChannelArgs_Workaround());
  }
}
ChannelArgs_Workaround._fqn = 'service.ChannelArgs.Workaround';
ChannelArgs_Workaround._fields = NewFields([[1, {
  name: 'cronetCompression',
  json: 'cronet_compression',
  type: 11,
  ctor: () => values__Value
}]]);
export class ConfigDescriptor extends ProtoMessage {
  static fromBinary(data) {
    return this.fromBinaryMerge(data, new ConfigDescriptor());
  }
}
ConfigDescriptor._fqn = 'service.ConfigDescriptor';
ConfigDescriptor._fields = NewFields([[1, {
  name: 'namespace',
  json: 'namespace',
  type: 9
}]]);
export class Namespaces extends ProtoMessage {
  static fromBinary(data) {
    return this.fromBinaryMerge(data, new Namespaces());
  }
}
Namespaces._fqn = 'service.Namespaces';
Namespaces._fields = NewFields([[1, {
  name: 'status',
  json: 'status',
  type: 14
}], [2, {
  name: 'namespaces',
  json: 'namespaces',
  type: 11,
  repeated: true,
  ctor: () => Namespaces_Namespace
}]]);
export class Namespaces_Namespace extends ProtoMessage {
  static fromBinary(data) {
    return this.fromBinaryMerge(data, new Namespaces_Namespace());
  }
}
Namespaces_Namespace._fqn = 'service.Namespaces.Namespace';
Namespaces_Namespace._fields = NewFields([[1, {
  name: 'name',
  json: 'name',
  type: 9
}], [2, {
  name: 'content',
  json: 'content',
  type: 12
}]]);
export class Service extends ProtoMessage {
  static fromBinary(data) {
    return this.fromBinaryMerge(data, new Service());
  }
}
Service._fqn = 'service.Service';
Service._fields = NewFields([[1, {
  name: 'channelArgs',
  json: 'channel_args',
  type: 11,
  ctor: () => ChannelArgs
}]]);
